import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15.662 11.628l2.229 -1.496a1.2 1.2 0 0 0 -.309 -2.228l-8.013 -2.303m-5.569 -1.601l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l4.907 4.907a1.067 1.067 0 0 0 1.509 0l.524 -.524","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconPointerOff = createReactComponent('outline', 'pointer-off', 'PointerOff', __iconNode);

export default IconPointerOff;